export default "__VITE_ASSET__DoHz07th__"